import React from 'react';
import {
  Text, Link, SingleMessage,
  Internal
} from '@comicrelief/component-library';
import Layout from '../components/Layout/Layout';
import { SEO, SEO_PAGE_TYPES } from '../components/SEO/SEO';

const default404 = () => (
  <Layout>
    <article data-test="404">
      <SingleMessage
        backgroundColor="grey_light"
        copyFirst={false}
        paddingTop="4rem"
        paddingBottom="4rem"
      >
        <Text tag="h1" textAlign="center">
          Well... This is awkward!
        </Text>
        <Text tag="p" textAlign="center">
          We can&apos;t seem to find the page you&apos;re looking for.
        </Text>
        <Text tag="p" textAlign="center">
          This might be because you&apos;ve accidentally typed the web address incorrectly or
          perhaps the page you&apos;re looking for has been removed, updated or deleted.
        </Text>

        <Text tag="p" textAlign="center">
          <Link
            color="red"
            href="/"
            target="self"
            type="button"
            icon={<Internal colour="white" />}
            fullWidth={false}
          >
            Back to homepage
          </Link>
        </Text>

      </SingleMessage>
    </article>
  </Layout>
);

export const Head = props => (
  <SEO
    title="404"
    description="Well... this is awkward! We can't seem to find the page you're looking for."
    pathName="404"
    allData={props}
    pageType={SEO_PAGE_TYPES[404]}
  />
);

export default default404;
